/* Sable & Ochre — Design Polish: extra scroll flourishes layered on top of
   the existing museum walkthrough (museum.js). Loads after it, and after
   GSAP/ScrollTrigger, which are already registered there. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var hasGsap = !!(window.gsap && window.ScrollTrigger);
    if (hasGsap) gsap.registerPlugin(ScrollTrigger);

    /* ---- 1. Sitewide scroll-progress bar ---- */
    var bar = document.querySelector('.mw-progress');
    if (bar && !reduced) {
      if (hasGsap) {
        gsap.to(bar, {
          scaleX: 1,
          ease: 'none',
          scrollTrigger: { start: 0, end: 'max', scrub: 0.3 }
        });
      } else {
        var onScroll = function () {
          var h = document.documentElement;
          var max = h.scrollHeight - h.clientHeight;
          var pct = max > 0 ? h.scrollTop / max : 0;
          bar.style.transform = 'scaleX(' + pct + ')';
        };
        document.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }
    }

    /* ---- 2. Hero headline: word-by-word stagger entrance ----
       When the entry gate is present the hero sits behind a closed door,
       so running this on load would spend the whole animation unseen and
       reveal a static headline on entry. Wait for the gate's hp:enter.
       Note the hiding only ever happens inside runHero — if that event
       never arrives, the headline is simply already visible. */
    var heroWords = document.querySelectorAll('.mw-entrance .mw-heading .mw-word');
    if (heroWords.length) {
      var runHero = function () {
        if (reduced || !hasGsap) {
          heroWords.forEach(function (w) { w.style.opacity = 1; });
          return;
        }
        gsap.set(heroWords, { yPercent: 115, rotate: 3, opacity: 0 });
        gsap.to(heroWords, {
          yPercent: 0,
          rotate: 0,
          opacity: 1,
          duration: 0.9,
          ease: 'power3.out',
          stagger: 0.06,
          delay: 0.2
        });
      };

      var gate = document.querySelector('.hp-gate');
      var gateIsClosed = gate && !gate.classList.contains('is-gone');
      if (gateIsClosed) {
        document.addEventListener('hp:enter', runHero, { once: true });
      } else {
        runHero();
      }
    }

    /* ---- 3. Card grids: cascading stagger reveal, replacing the plain
       single-fade so pieces visibly cascade in one after another ---- */
    document.querySelectorAll('.mw-grid').forEach(function (grid) {
      var pieces = grid.querySelectorAll('.mw-piece[data-mreveal]');
      if (!pieces.length) return;

      if (reduced) {
        pieces.forEach(function (el) { el.classList.add('mw-in'); });
        return;
      }

      if (hasGsap) {
        gsap.set(pieces, { opacity: 0, y: 28 });
        ScrollTrigger.batch(pieces, {
          start: 'top 88%',
          onEnter: function (batch) {
            gsap.to(batch, {
              opacity: 1,
              y: 0,
              stagger: 0.09,
              duration: 0.7,
              ease: 'power2.out',
              overwrite: true
            });
          }
        });
      } else {
        pieces.forEach(function (el, i) {
          setTimeout(function () { el.classList.add('mw-in'); }, i * 80);
        });
      }
    });

    /* ---- 4. Signature paw mark draws itself in as the entrance scrolls by ---- */
    var pawShapes = document.querySelectorAll('.mw-paw-mark ellipse');
    if (pawShapes.length) {
      if (reduced) {
        pawShapes.forEach(function (s) { s.style.strokeDashoffset = 0; });
      } else if (hasGsap) {
        pawShapes.forEach(function (shape) {
          var len = shape.getTotalLength();
          gsap.set(shape, { strokeDasharray: len, strokeDashoffset: len });
        });
        gsap.to(pawShapes, {
          strokeDashoffset: 0,
          ease: 'none',
          stagger: 0.15,
          scrollTrigger: {
            trigger: '.mw-entrance',
            start: 'top 70%',
            end: 'top 15%',
            scrub: 0.5
          }
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
